import { render, staticRenderFns } from "./TopbarMemosButton.vue?vue&type=template&id=000685f4&scoped=true&"
import script from "./TopbarMemosButton.vue?vue&type=script&lang=js&"
export * from "./TopbarMemosButton.vue?vue&type=script&lang=js&"
import style0 from "./TopbarMemosButton.vue?vue&type=style&index=0&id=000685f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000685f4",
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
